export default {
  async get(url, { headers, noCache, credentials, mode, query }) {
    credentials = credentials || 'same-origin';
    let queryString = this._buildQueryString(query, noCache);
    let req = new Request(url + queryString, {
      method: 'GET',
      headers: this._buildHeaders(headers, noCache),
      credentials,
      mode
    });

    let response = await fetch(req);
    return response;
  },
  async post(url, { headers, noCache, credentials, data }) {
    credentials = credentials || 'same-origin';

    let body = JSON.stringify(data);
    if ('Content-Type' in headers) {
      headers['Content-Length'] = body.length;
    }

    let req = new Request(url, {
      method: 'POST',
      headers: this._buildHeaders(headers, noCache),
      body,
      credentials
    });

    let response = await fetch(req);
    return response;
  },
  _buildQueryString(query, noCache) {
    if (!query) {
      query = {};
    }
    let queryString = '';
    if (noCache) {
      query.v = +new Date();
    }
    for (let key of Object.keys(query)) {
      queryString += `&${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`;
    }
    if (queryString) {
      queryString = queryString.replace('&', '?');
    }

    return queryString;
  },
  _buildHeaders(headers = {}, nocache = false) {
    const _headers = Object.assign({}, headers);
    if (nocache) {
      _headers['Cache-Control'] = 'no-cache';
      _headers.Pragma = 'no-cache';
      _headers.Expires = 0;
    }

    return _headers;
  }
};
